import React from 'react';
import { DateRange as DateRangeComponent, DateRangeProps } from 'react-date-range';

const DateRange = (props: DateRangeProps) => {
  const LocalDateRange = DateRangeComponent as unknown as React.ComponentType<DateRangeProps>;
  return <LocalDateRange {...props} />;
};

export default DateRange;
